

import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, catchError } from 'rxjs/operators';
import { SecurityService } from './';
import { CONSTANTS } from 'app/constants';


@Injectable({
    providedIn: 'root',
  })
export class SecurityGuard implements CanActivate {

    constructor(private router: Router, private securityService: SecurityService) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
        : Observable<boolean> | Promise<boolean> | boolean {

        
        let requiredRole = route.data['role'];
        let requiredPermission = route.data['pagePermission'];

        return this.securityService.getAuths()
            .pipe(
                map(data => {
                    let result = data;

                    if (result.userName) {

                        if (requiredRole) {
                            if (requiredRole === CONSTANTS.userRoles.admin && !result.roles.isAdmin) {
                                return this.returnForbidden();
                            }

                            if (requiredRole === CONSTANTS.userRoles.schoolInspector && !result.roles.isSchoolInspector && !result.roles.isAdmin) {
                                return this.returnForbidden();
                            }
                        }

                        return true;
                    } else {
                        return this.returnForbidden();
                    }
            }),
            catchError(error => {
                this.router.navigate(['login']);
                return of(false);
            }));

    }

    private returnForbidden(): boolean {
        this.router.navigate(['login']);
                        
        return false;
    }
}